import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('framework-listing-lib', {
  library: 'framework-listing-lib'
});